import { Link } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";
import { Home, Search } from "lucide-react";

const NotFound = () => {
  useEffect(() => {
    // Track 404-Fehler in Plausible Analytics
    // Erfasst den fehlerhaften Pfad für detaillierte Analyse
    trackEvent('404 Error', {
      path: window.location.pathname,
      referrer: document.referrer || 'direct'
    });
    
    // Console-Logging für Entwicklung (kann später entfernt werden)
    console.error("404 Error: User attempted to access non-existent route:", window.location.pathname);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <div className="flex-grow flex items-center justify-center px-6 py-20">
        <div className="text-center max-w-2xl">
          {/* 404 Hero */}
          <div className="mb-8">
            <h1 className="text-8xl md:text-9xl font-bold text-primary mb-4">404</h1>
            <div className="w-24 h-1 bg-primary mx-auto mb-8"></div>
          </div>
          
          {/* Error Message */}
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Seite nicht gefunden
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-lg mx-auto">
            Die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben. 
            Möglicherweise haben Sie einen veralteten Link verwendet.
          </p>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button size="lg" className="px-8">
                <Home className="w-5 h-5 mr-2" />
                Zur Startseite
              </Button>
            </Link>
            <Link to="/wissen">
              <Button size="lg" variant="outline" className="px-8">
                <Search className="w-5 h-5 mr-2" />
                Wissen durchsuchen
              </Button>
            </Link>
          </div>
          
          {/* Helpful Links */}
          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground mb-4">
              Vielleicht finden Sie das Gesuchte hier:
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/programm" className="text-primary hover:underline text-sm">
                Das Programm
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/modul-0" className="text-primary hover:underline text-sm">
                KI-Grundlagen
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/experten" className="text-primary hover:underline text-sm">
                Experten
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/faq" className="text-primary hover:underline text-sm">
                FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
